import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

export default BootstrapVue



// WEBPACK FOOTER //
// ./src/plugins/bootstrap-vue.js